// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation

import { useEffect, useState } from "react";

import Client from "@src/helpers/contentful";

interface BannerEntry {
  title: string;
  url: string;
  linkCta: string;
}

export const useBanner = () => {
  const [banner, setBanner] = useState<BannerEntry>();

  useEffect(() => {
    Client.getEntries({ content_type: "siteBanner", limit: 1 }).then(
      (response) => {
        response.items.forEach((f: any) => {
          setBanner({
            title: f.fields?.title,
            url: f.fields?.url,
            linkCta: f.fields?.cta,
          });
        });
      },
    );
  }, []);

  return { banner };
};
